import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { I18nProvider } from "./contexts/I18nContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppWidget from "./components/WhatsAppWidget";
import Home from "./pages/Home";
import Destinations from "./pages/Destinations";
import BlogPost from "./pages/BlogPost";

function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <div className="App font-body" data-testid="app-root">
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/destinations" element={<Destinations />} />
              <Route path="/destinations/:slug" element={<BlogPost />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppWidget />
        </div>
      </BrowserRouter>
    </I18nProvider>
  );
}

export default App;
